import React from 'react'
import PropTypes from 'prop-types'
import { 
  Button, 
  Typography, 
  Box, 
  Paper, 
} from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import { useForm, FormProvider } from 'react-hook-form'
import ReviewSummary from './ReviewSummary'

const FormReview = ({ steps, formData, customer, onBack, onSubmit }) => {
  const classes = useStyles()

  const methods = useForm({
    mode: 'onBlur',
    reValidateMode: 'onBlur',
    defaultValues: formData, // Usar formData como valores padrão
  })

  return (
    <FormProvider {...methods}>
      <div className={classes.wrapper}>
        <Paper elevation={2} className={classes.paper}>
          <Typography variant="h5" className={classes.title}>
            Revisão do Formulário
          </Typography>
          
          <Typography variant="body2" className={classes.subtitle}>
            Revise suas respostas antes de enviar o formulário
          </Typography>

          <Box className={classes.content}>
            <ReviewSummary 
              steps={steps}
              formData={formData}
              customer={customer}
            />
          </Box>

          <Box className={classes.buttonContainer}>
            <Button
              variant="outlined"
              color="primary"
              onClick={onBack}
              className={classes.backButton}
            >
              Voltar
            </Button>
            
            <Button
              variant="contained"
              color="primary"
              onClick={onSubmit}
              className={classes.submitButton}
            >
              Enviar Formulário
            </Button>
          </Box>
        </Paper>
      </div>
    </FormProvider>
  )
}

const useStyles = makeStyles((theme) => ({
  wrapper: {
    padding: '20px 5px',
    display: 'flex',
    justifyContent: 'center',
  },
  paper: {
    width: '100%',
    maxWidth: '410px',
    padding: '24px',
  },
  title: {
    marginBottom: '8px',
    fontWeight: 600,
    textAlign: 'center',
  },
  subtitle: {
    marginBottom: '24px',
    textAlign: 'center',
    color: theme.palette.text.secondary,
  },
  content: {
    marginBottom: '24px',
    minHeight: '200px',
  },
  accordion: {
    marginBottom: '8px',
    '&:before': {
      display: 'none',
    },
  },
  accordionSummary: {
    backgroundColor: theme.palette.grey[50],
    minHeight: '48px',
    '&.Mui-expanded': {
      minHeight: '48px',
    },
  },
  accordionDetails: {
    flexDirection: 'column',
    padding: '16px',
  },
  stepTitle: {
    fontWeight: 500,
  },
  fieldsContainer: {
    width: '100%',
  },
  buttonContainer: {
    display: 'flex',
    gap: '12px',
    justifyContent: 'space-between',
  },
  backButton: {
    flex: 1,
  },
  submitButton: {
    flex: 1,
  },
}))

FormReview.propTypes = {
  steps: PropTypes.array.isRequired,
  formData: PropTypes.object.isRequired,
  customer: PropTypes.object,
  onBack: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
}

export default FormReview